import $ from 'jquery'

const SEARCH_OPEN_CLASS = 'search-open'
class HeaderSearch {
  constructor(element) {
    if (!element) return

    this.element = element

    this._iniVars()

    this._iniSearch()

    this.toggleMobileSearch()
  }

  _iniVars() {
    this.header = $(this.element).parents('.header')
    this.form = $('form', this.element)
    this.searhToggler = $('.header__search__label', this.element)
    this.searchInput = $("input[type='text']", this.element)
    this.searhClear = $('.header__search__clear', this.element)
    this.mobIcon = $('.header__search-mob', this.element)
    this.search = $('.header__search', this.element)
  }

  _iniSearch() {
    this.searhToggler.on('click', (_) => {
      this.header.toggleClass(SEARCH_OPEN_CLASS)
    })

    $(document).on('click', (e) => {
      if (!$(e.target).closest('.header__search').length) {
        this.header.removeClass(SEARCH_OPEN_CLASS)
      }
    })

    this.searhClear.on("click", (_) => {
      if ($(window).width() > 1278) {
          console.log('is desktop');
          this.searchInput.val('');
          this.header.removeClass(SEARCH_OPEN_CLASS);
      }
      if ($(window).width() < 1278) {
        $(this.element).removeClass('show')
        $('.header__burger , .header__logo, .header__search-mob').show()
      }
  });

    this.form.on('submit', (e) => {
      e.preventDefault()
      if (this.searchInput.val().length >= 3) {
        this.searchResultsRedirect()
      }
    })
  }

  searchResultsRedirect() {
    const redirectUrlBase = $(this.element).data('redirect-url')
    const searchQuery = this.searchInput.val()
    const redirectUrl = `${redirectUrlBase}?term=${searchQuery}`
    window.location.href = redirectUrl
  }

  toggleMobileSearch() {
    $('.header__search-mob').on('click', (e) => {
      const $item = $(e.currentTarget)

      if($('body').hasClass('mob-menu-open')){
        $('body').removeClass('mob-menu-open')
      }
      console.log('click')
      $(this.element).addClass('show')
      $('.header__burger , .header__logo').hide()
      $item.hide()
      
    })
  }
}
export default HeaderSearch
